module.exports = __webpack_public_path__ + "static/media/icon_up.28b72be2.svg";